import { render } from "./IssueArticleDetails.vue?vue&type=template&id=4b3207b2"
import script from "./IssueArticleDetails.vue?vue&type=script&lang=js"
export * from "./IssueArticleDetails.vue?vue&type=script&lang=js"

import exportComponent from "/Users/shanbhad/Documents/BitBucket/storyfinder2_ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__